module.exports = __webpack_public_path__ + "img/icon5.05de8865.svg";